/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsUpdate } from "../funcs/assistantsUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Assistant } from "../models/components/assistant.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateAssistantRequest,
  UpdateAssistantSecurity,
} from "../models/operations/updateassistant.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AssistantsUpdateMutationVariables = {
  request: UpdateAssistantRequest;
  security?: UpdateAssistantSecurity | undefined;
  options?: RequestOptions;
};

export type AssistantsUpdateMutationData = Assistant;

export type AssistantsUpdateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateAssistant assistants
 *
 * @remarks
 * Update an assistant.
 */
export function useAssistantsUpdateMutation(
  options?: MutationHookOptions<
    AssistantsUpdateMutationData,
    AssistantsUpdateMutationError,
    AssistantsUpdateMutationVariables
  >,
): UseMutationResult<
  AssistantsUpdateMutationData,
  AssistantsUpdateMutationError,
  AssistantsUpdateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAssistantsUpdateMutation(client, options),
    ...options,
  });
}

export function mutationKeyAssistantsUpdate(): MutationKey {
  return ["@gram/client", "assistants", "update"];
}

export function buildAssistantsUpdateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AssistantsUpdateMutationVariables,
  ) => Promise<AssistantsUpdateMutationData>;
} {
  return {
    mutationKey: mutationKeyAssistantsUpdate(),
    mutationFn: function assistantsUpdateMutationFn({
      request,
      security,
      options,
    }): Promise<AssistantsUpdateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(assistantsUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
